import { render, staticRenderFns } from "./DouMeiDivide.vue?vue&type=template&id=775d131b&scoped=true"
var script = {}
import style0 from "./DouMeiDivide.vue?vue&type=style&index=0&id=775d131b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d131b",
  null
  
)

export default component.exports